module.exports = __webpack_public_path__ + "b0831fd922c50af49d803f5db7b50cf3.pdf";